import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading, Modal, SystemText } from 'e4shared';
import { apiGet } from 'services';
import { e4Format } from 'helpers/dates';
import BlobImage from 'components/blobImage';

export const TeamViews = ({ profile, range, offset }) => {
    const [data, setData] = useState([]);
    const [profileShow, setProfileShow] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    const st = (path, ...rest) => SystemText(`User121/e4Metrics/Details/TeamViews/Popup/${path}`, ...rest);

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        const qs = `?range=${range}&offset=${offset}`;
        Boolean(profile) && apiGet(`team-performance-views/${profile.id}${qs}`, guid, response => gotResponse(response));
    }, [guid, profile.id, range]);

    const showRow = id => (profileShow.indexOf(id) >= 0 ? '' : 'hidden');
    const staffIcon = id => (profileShow.indexOf(id) >= 0 ? 'minus' : 'plus');
    const toggleStaff = id => {
        const value = profileShow.indexOf(id) >= 0 ? profileShow.filter(x => x !== id) : profileShow.concat([id]);
        setProfileShow(value);
    };

    let people = data.reduce((c, d) => (c.some(x => x.profile_Id === d.profile_Id) ? c : c.concat([d])), []);

    return (
        <div>
            {people.map(p => {
                const views = data.filter(d => d.profile_Id === p.profile_Id);
                return (
                    <div key={`profile-${p.profile_Id}`}>
                        <div className="mb5 flex flex-center">
                            <i
                                onClick={() => toggleStaff(p.profile_Id)}
                                className={`pointer fa fa-${staffIcon(p.profile_Id)}-square mr5`}
                            />
                            <BlobImage height="20" className="img-circle mr5" src={p.avatar} folder="avatar" />
                            <span className="mr5">
                                <Link title={st('Title', p.full_Name)} to={`/objectives/${p.profile_Id}`}>
                                    {p.full_Name}
                                </Link>
                            </span>
                            <span>({st(`Views${views.length !== 1 ? '/Plural' : ''}`, views.length)})</span>
                        </div>
                        <div className={`${showRow(p.profile_Id)} ml43 mb5`}>
                            {views.map(o => (
                                <div key={`view-${o.profile_Id}-${o.id}`}>
                                    <div>{e4Format(o.date_Set)}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TeamViews;
